import React, { useState } from 'react';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import PdfFile from 'Assets/PdfFile/TAS-Privacy-Policy.pdf';
import CustomModal from 'Common/CustomModal';


export default function PrivacyPolicy({ openModal, handleClose, title }) {
    const [numPages, setNumPages] = useState(null);

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    return (
        <CustomModal
            open={openModal}
            handleClose={handleClose}
            maxWidth='sm'
            title={title}
        >
            <div style={{ overflowX: "hidden" }}>
                <Document file={PdfFile} onLoadSuccess={onDocumentLoadSuccess} loading={''}>
                    {[...Array(numPages).keys()].map((page, i) => (
                        <React.Fragment key={i}>
                            <Page pageNumber={page + 1} scale={1} />
                        </React.Fragment>
                    ))}
                </Document>
            </div>
        </CustomModal>
    );
}